import { useFormContext } from 'react-hook-form'

import { FormError, FormField, FormItem, FormLabel, SelectInput } from '@fortem-monorepo/react-ui'
import { BatchExecutor } from '@fortem-monorepo/web-sdk'

import { SchemaType } from '@/components/forms/RunRiskCalibrationForm/RunRiskCalibrationForm.schema'
import { INSTANCE_TAGS } from '@/components/forms/RunRiskCalibrationForm/enums'
import { useCloudPricingState } from '@/react-query/queries/risk'

export interface InstanceTagFieldProps {}

export const InstanceTagField: React.FC<InstanceTagFieldProps> = () => {
  const { control, setValue } = useFormContext<SchemaType>()
  const { cloudPricingStatus } = useCloudPricingState()

  return (
    <FormField
      name="instance_tag"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Instance</FormLabel>
              <FormError />
            </div>
            <SelectInput
              className={'w-full'}
              value={value}
              // @ts-ignore
              valueDisabled={(val: BatchExecutor.InstanceTag) => {
                return val === 'AWS_INSTANCE_X' && cloudPricingStatus !== 'RUNNING'
              }}
              onValueChange={(value: BatchExecutor.InstanceTag) =>
                setValue('instance_tag', value, {
                  shouldValidate: true,
                })
              }
              options={INSTANCE_TAGS.map((v) => ({
                label: v,
                value: v,
              }))}
            />
          </FormItem>
        )
      }}
    />
  )
}
